import { render, staticRenderFns } from "./BracketPrint.vue?vue&type=template&id=7ff3518e&scoped=true"
import script from "./BracketPrint.vue?vue&type=script&lang=js"
export * from "./BracketPrint.vue?vue&type=script&lang=js"
import style0 from "./BracketPrint.vue?vue&type=style&index=0&id=7ff3518e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3518e",
  null
  
)

export default component.exports